import Mapbox from 'index.vue';
import { BaseFeatureLayer } from './baseFeatureLayer';
import i18n from '../../../main';
export class HeatMapLayer {
    protected mapboxInstance: InstanceType<typeof Mapbox>;
    protected heatMapLayer: BaseFeatureLayer;
    

    constructor(mapboxInstance: InstanceType<typeof Mapbox>) {
        this.mapboxInstance = mapboxInstance;

        this.heatMapLayer = new BaseFeatureLayer(mapboxInstance, 'top', 'heatmap-layer', 'heatmap-source', 'heatmap', {}, {
            "heatmap-weight": [
                "interpolate",
                ["linear"],
                ["get", "weight"],
                0, 0,
                255, 1
            ],
            "heatmap-intensity": [
                "interpolate",
                ["linear"],
                ["zoom"],
                0, 1,
                10, 2,
                15, 5
            ],
            "heatmap-color": [
                "interpolate",
                ["linear"],
                ["heatmap-density"],
                0, "rgba(255,85,85,0)",
                0.2, "rgba(255,85,85,0.2)",
                0.4, "rgba(255,85,85,0.4)",
                0.6, "rgba(255,85,85,0.6)",
                0.8, "rgba(255,85,85,0.8)",
                1, "rgba(255,85,85,1)"
            ],
            "heatmap-radius": [
                "interpolate",
                ["linear"],
                ["zoom"],
                0, 1,
                5, 20,
                10, 80,
                15, 165,
                20, 240
            ],
            "heatmap-opacity": [
                "interpolate",
                ["linear"],
                ["zoom"],
                7, 1,
                15, 0.7
            ]
        }
, true);
       
        
    }
    
    public DataChanged = async () => {
        if (this.mapboxInstance.heatMapPoints != null) {
            const points = this.mapboxInstance.heatMapPoints.flat();
            this.heatMapLayer.SetFeatures(points.map((point: any) => ({
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [point.longitude, point.latitude]
                },
                "properties": {
                    "weight": point.weight
                }
            })));
        }
    };
}